import React, { useEffect } from "react";
import { generalErrors } from "../../consts/ErrorMessages.js";
import Style from "../../styles/js/StyleABMCategories.js";
import * as Constants from "../../consts/Constants.js";
import Axios from "axios";
import ListWithCheckbox from "./ListWithCheckbox";
import * as ScreenText from "../../consts/ScreenText.js";
import Header from "./Header";
import Dialog from "./Dialog";
import Alert from "../../components/common/SnackAlert.js";

export default function ABMCategories() {
  const [categories, setCategories] = React.useState([]);
  const [subcategories, setSubcategories] = React.useState([]);
  const [categorySelected, setCategorySelected] = React.useState(-1);
  const [newCategory, setNewCategory] = React.useState({});
  const [openDialog, setOpenDialog] = React.useState(false);
  const [titleDialog, setTitleDialog] = React.useState({});

  const [alertOpen, setAlertOpen] = React.useState(false);

  const handleClickOpenCategory = () => {
    setOpenDialog(true);
    setTitleDialog(ScreenText.ABM_CATEGORIES_TITLE_DIALOG_CATEGORY);
    setNewCategory({});
  };
  const handleClickOpenSubcategory = () => {
    setOpenDialog(true);
    setTitleDialog(ScreenText.ABM_CATEGORIES_TITLE_DIALOG_SUBCATEGORY);
    let newSubcategory = {
      mainCategoryId: categorySelected,
    };
    setNewCategory(newSubcategory);
  };

  const saveCategory = (newName) => {
    const newItem = { ...newCategory, name: newName };
    Axios.post(Constants.FINAL_URL_CATEGORIES, newItem).then((response) => {
      if (response.status === Constants.RESPONSE_CREATED) {
        if (newItem.mainCategoryId === undefined) {
          let newCategories = [];
          categories.map((category) => newCategories.push(category));
          newCategories.push(response.data);
          setCategories(newCategories);
        } else {
          let newSubcategories = [];
          subcategories.map((subcategory) =>
            newSubcategories.push(subcategory)
          );
          newSubcategories.push(response.data);
          setSubcategories(newSubcategories);
        }
      } else {
        setAlertOpen(true);
      }
    });
    setOpenDialog(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const getCategories = () => {
    Axios.get(Constants.FINAL_URL_ALL_CATEGORIES).then((response) => {
      let data = response.data;
      setCategories(data);
    });
  };

  const getSubcategories = (category) => {
    Axios.get(
      Constants.FINAL_URL_CATEGORIES +
        category +
        "/" +
        Constants.URL_ALL_SUBCATEGORIES
    ).then((response) => {
      let data = response.data;
      setSubcategories(data);
    });
  };

  const handleActivatedChange = (item) => {
    const newItem = { ...item, activated: !item.activated };
    Axios.put(Constants.FINAL_URL_CATEGORIES + item.id, newItem).then(
      (response) => {
        if (response.status === Constants.RESPONSE_NO_CONTENT) {
          if (newItem.mainCategoryId === undefined) {
            let newCategories = [];
            categories.map((category) =>
              category.id !== newItem.id
                ? newCategories.push(category)
                : newCategories.push(newItem)
            );
            setCategories(newCategories);
            if (categorySelected === newItem.id) {
              let newSubcategories = [];
              subcategories.map((subcategory) =>
                newSubcategories.push({
                  ...subcategory,
                  activated: newItem.activated,
                })
              );
              setSubcategories(newSubcategories);
            }
          } else {
            let newSubcategories = [];
            subcategories.map((subcategory) =>
              subcategory.id !== newItem.id
                ? newSubcategories.push(subcategory)
                : newSubcategories.push(newItem)
            );
            setSubcategories(newSubcategories);
          }
        } else {
          setAlertOpen(true);
        }
      }
    );
  };

  const handleCategories = (idCategory) => {
    getSubcategories(idCategory);
    setCategorySelected(idCategory);
  };

  useEffect(() => {
    getCategories();
  }, []);

  const style = Style();

  return (
    <div className={style.root}>
      <Header />
      <ListWithCheckbox
        title={ScreenText.ABM_CATEGORIES_TITLE_CATEGORIES}
        onItemClick={handleCategories}
        items={categories}
        titleButton={ScreenText.ABM_CATEGORIES_TITLE_BUTTON_CATEGORIES}
        handleActivatedChange={handleActivatedChange}
        actionButton={handleClickOpenCategory}
        showButton={true}
      />
      <ListWithCheckbox
        title={ScreenText.ABM_CATEGORIES_TITLE_SUBCATEGORIES}
        items={subcategories}
        titleButton={ScreenText.ABM_CATEGORIES_TITLE_BUTTON_SUBCATEGORIES}
        handleActivatedChange={handleActivatedChange}
        actionButton={handleClickOpenSubcategory}
        showButton={categorySelected !== -1}
      />
      <Dialog
        open={openDialog}
        titleDialog={titleDialog}
        handleClose={handleClose}
        save={saveCategory}
      />
      <Alert
        open={alertOpen}
        setOpen={setAlertOpen}
        mensaje={generalErrors.server}
        severity="error"
      ></Alert>
    </div>
  );
}
